import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { Operacion, OperacionPatch } from '../../model'

export class ApiBuyAndSell {
  fetch = async (ids: number[]): Promise<Array<Operacion>> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)
    let filter = ids.map((id: number) => `id eq ${id}`).join(' or ')

    return await AxiosInstance.get(
      `${apiSuffixUrl}/oData/Operaciones?&$filter=(${filter})&$expand=elementoLogistico,contraparte,empresa,posicion($expand=trade)&$orderby=fechaOperacion,elementoLogistico/descripcion`
    ).then(response => {
      return response.data.value
    })
  }

  cancel = async (operacion: OperacionPatch): Promise<any> => {
    const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentFrontServices)

    return await AxiosInstance.patch(
      `${apiSuffixUrl}/oData/Operaciones(${operacion.id},'${operacion.tipoOperacion}')`,
      operacion
    ).then(() => {
      return true
    })
  }
}
